import { useCallback, useEffect, useRef, useState } from 'react';
import { scoreListeningAnswer } from './listeningApi';

export function restoredListeningProgress(round) {
  if (!round?.listening_contract) return null;
  const questions = round.questions || [];
  const scored = questions.filter((q) => typeof q.is_correct === 'boolean' && q.selected_answer != null);
  return { question: questions.find((q) => typeof q.is_correct !== 'boolean') || questions.at(-1) || null,
    answers: scored.map((q) => ({ question_id: q.id, selected_answer: q.selected_answer, is_correct: q.is_correct })),
    correctCount: scored.filter((q) => q.is_correct).length };
}

export default function useListeningAnswer({ round, question, boardSessionId, boardToken }) {
  const [grading, setGrading] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(null);
  const key = `${round?.round_id}:${question?.id}:${boardSessionId}`;
  const currentKey = useRef(key);
  currentKey.current = key;
  useEffect(() => {
    setGrading(false); setError('');
    return () => { pending.current?.abort(); pending.current = null; };
  }, [key]);
  const grade = useCallback(async (choice) => {
    if (!round?.listening_qa_scoring || pending.current) return null;
    const controller = new AbortController();
    pending.current = controller;
    setGrading(true); setError('');
    try {
      const result = await scoreListeningAnswer(round.round_id, question.id, choice,
        { boardSessionId, boardToken, signal: controller.signal });
      return currentKey.current === key && !controller.signal.aborted ? result : null;
    } catch (failure) {
      if (currentKey.current === key && !controller.signal.aborted) setError('Your answer could not be checked. Try again.');
      return null;
    } finally {
      if (pending.current === controller) {
        pending.current = null;
        setGrading(false);
      }
    }
  }, [round, question, boardSessionId, boardToken, key]);
  return { grade, grading, error };
}
